import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BrokerSidebar from '../components/BrokerSidebar';
import BrokerContent from '../components/BrokerContent';
import Header from '../../components/Header';
import './BrokerDashboard.css';

const BrokerDashboard = ({ setSupertype, setType, resetListings }) => {
    const location = useLocation();
    const [selectedSection, setSelectedSection] = useState('Certs'); // Default to 'Certs'
    const [certNumber, setCertNumber] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSectionSelect = (section) => {
        setSelectedSection(section);
    };

    useEffect(() => {
        // Handle navigation with state for section and certNumber
        if (location.state) {
            setSelectedSection(location.state.section || 'Certs');
            setCertNumber(location.state.certNumber || '');
        }
    }, [location.state]);

    return (
        <div className="broker-dashboard">
            <Header setSupertype={setSupertype} setType={setType} resetListings={resetListings} />
            {loading && (
                <div className="fast-loading-indicator">
                    <span className="dot one">.</span>
                    <span className="dot two">.</span>
                    <span className="dot three">.</span>
                </div>
            )}
            <div className="broker-main">
                <BrokerSidebar 
                    onSectionSelect={handleSectionSelect} 
                    selectedSection={selectedSection} 
                />
                <BrokerContent 
                    selectedSection={selectedSection} 
                    setSelectedSection={setSelectedSection}
                    certNumber={certNumber} 
                />
            </div>
        </div>
    );
};

export default BrokerDashboard;
